import React, { useEffect, useMemo, useRef, useState, createContext, useContext } from "react";
import { Card, ConfirmModal, DropDown, Table } from "../../../utils/CustomComponents";
import { ReactComponent as PaperPlus } from "../../../img/Section/Paper Plus.svg";
import { ReactComponent as Search } from "../../../img/Section/Search.svg";
import gsap, { Back } from "gsap";
import avatar from "../../../img/Section/avatar.png";
import { Route, Switch, useHistory, useRouteMatch } from "react-router";
import { Link } from "react-router-dom";
import profileIcon from "../../Dashboard/Components/memo.png";
const staffs = {
    id: 1,
    id_table: "WA-0219",
    icon: avatar,
    name: "Ademola Samson",
    email: "Ademolasamson@gmail.com",
    dept: "Operations",
    role: "Chief Executive",
    salary: 1e6,
    doj: "2021-10-23",
    staff_id: "wa-0219",
};
const List_of_staffs_payment_history_obj = [
    {
        avatar: profileIcon,
        name: "John Doe",
        email: "johndoe@gmail.com",
        staff_id: "wa-0219",
        role: "General Manager",
        amount_paid: "1000",
        date: "21-04-2021",
    },
];
for (let index = 0; index < 10; index++) {
    List_of_staffs_payment_history_obj.push(List_of_staffs_payment_history_obj[0]);
}
export function StaffsPanel() {
    const match = useRouteMatch();
    const SelectedStaff = createContext();
    const [Selected_Staff_id, setSelected_Staff_id] = useState(null);
    return (
        <div id="dashboard_panel" className="panel_content company staffs">
            <SelectedStaff.Provider value={{ Selected_Staff_id, setSelected_Staff_id }}>
                <Switch>
                    <Route path={`${match.path}/pension_payment`}>
                        <PensionPayment />
                    </Route>
                    <Route path={`${match.path}/view_staff`}>
                        <ViewStaff />
                    </Route>
                    <Route path={`${match.path}/add_staff`}>
                        <AddStaff />
                    </Route>
                    <Route path={`${match.path}/`}>
                        <StaffsPage />
                    </Route>
                </Switch>
            </SelectedStaff.Provider>
        </div>
    );

    function StaffsPage() {
        const match = useRouteMatch();
        const utils = useRef();
        const [List_of_staffs_payment_history, setList_of_staffs_payment_history] = useState(
            List_of_staffs_payment_history_obj
        );
        const { setSelected_Staff_id } = useContext(SelectedStaff);
        useEffect(() => {
            const tl = gsap.timeline({ paused: true });
            tl.from(utils.current.children, {
                opacity: 0,
                scale: 0.7,
                duration: 1,
                stagger: { each: 0.125 },
                ease: Back.easeOut.config(2),
            });
            tl.play();
        }, []);

        const data = useMemo(
            () => [
                ...Array.from({ length: 20 }).map(() => {
                    return {
                        staff: (
                            <div className="name_wrapper">
                                <div className="avatar">
                                    <img src={staffs.icon} alt="" />
                                </div>
                                <div className="name_email">
                                    <div className="name">{staffs.name}</div>
                                    <div className="email">{staffs.email}</div>
                                </div>
                            </div>
                        ),
                        staff_id: staffs.id_table,
                        role: staffs.role,
                        salary: `$${staffs.salary.toString()}`,
                        action: (
                            <div className="view">
                                <Link
                                    to={`${match.url}/view_staff`}
                                    onClick={() => setSelected_Staff_id(staffs.staff_id)}
                                >
                                    <button>View</button>
                                </Link>
                            </div>
                        ),
                    };
                }),
            ],
            [match.url, setSelected_Staff_id]
        );

        const columns = useMemo(
            () => [
                {
                    Header: "Staff",
                    accessor: "staff",
                    minWidth: 250, // accessor is the "key" in the data
                },
                {
                    Header: "Staff Id",
                    accessor: "staff_id",
                },
                {
                    Header: "Role",
                    accessor: "role",
                },
                {
                    Header: "Salary",
                    accessor: "salary",
                },
                {
                    Header: "",
                    accessor: "action",
                },
            ],
            []
        );
        return (
            <>
                <div className="utils" ref={utils}>
                    <Card className="search" shadow="0px 4px 28px -13px rgba(0, 0, 0, 0.25)">
                        <input
                            type="text"
                            name="search_bar"
                            id="search"
                            placeholder="Search by ID or name"
                            onChange={({ target: { value } }) => {
                                value
                                    ? setList_of_staffs_payment_history(
                                          List_of_staffs_payment_history.filter(({ staff_id }) =>
                                              staff_id.toLowerCase().match(value.toLowerCase())
                                          )
                                      )
                                    : setList_of_staffs_payment_history(
                                          List_of_staffs_payment_history_obj
                                      );
                            }}
                        />
                        <Search />
                    </Card>
                    <Link to={`${match.url}/add_staff`}>
                        <button className="add_staff_btn">
                            <PaperPlus /> <span>Add new staff</span>
                        </button>
                    </Link>
                </div>
                <div className="table">
                    <div className="table_wrapper">
                        <Table
                            anim_delay={0.5}
                            columns={columns}
                            data={data}
                            no_data_text="No Matching Staff"
                            padding={32}
                        />
                    </div>
                </div>
            </>
        );
    }
    function PensionPayment() {
        const { Selected_Staff_id } = useContext(SelectedStaff); //here we get selected staff
        //id and use it to fecth all staff data
        //and render the page
        const [salary, setSalary] = useState(18850.43);
        const [Currency, setCurrency] = useState("USD");
        const currency_symbol_ref = useRef();
        useEffect(() => {
            switch (Currency) {
                case "USD":
                    currency_symbol_ref.current.innerHTML = "$";
                    break;
                case "EURO":
                    currency_symbol_ref.current.innerHTML = "&euro; ";
                    break;
                case "POUNDS":
                    currency_symbol_ref.current.innerHTML = "&#163; ";
                    break;
                default:
                    currency_symbol_ref.current.innerHTML = "$";
            }
        }, [Currency]);

        useEffect(() => {
            document.querySelector("#dashboard_panel.company").style.display = "block";
            return () => {
                document.querySelector("#dashboard_panel.company").style.display = "grid";
            };
        }, []);

        return (
            <div className="pension_payment ">
                <div className="input salary">
                    <h4 className="header">Enter Payment Amount</h4>
                    <div className="staking_input">
                        <div className="input_feild">
                            <span ref={currency_symbol_ref}></span>
                            <input
                                type="number"
                                name=""
                                id=""
                                value={salary}
                                onChange={({ target: { value } }) => {
                                    setSalary(value);
                                }}
                            />
                        </div>
                        <span className="divider"></span>
                        <DropDown
                            header="Select Currency"
                            removeOnExit={true}
                            index={1}
                            dropListArray={[
                                { render: "USD" },
                                { render: "EURO" },
                                { render: "POUNDS" },
                            ]}
                            initialOption={Currency}
                            setOption={setCurrency}
                            width="auto"
                            style={{ marginRight: 24 }}
                        />
                    </div>
                </div>
                <div className="cta">
                    <button className="btn_pry">Confirm</button>
                </div>
            </div>
        );
    }
    function ViewStaff() {
        const history = useHistory();
        const [Remove_Staff_Modal, setRemove_Staff_Modal] = useState(false);
        const { Selected_Staff_id } = useContext(SelectedStaff); //here we get selected staff
        //id and use it to fecth all staff data
        //and render the page
        const fetched_staff_details = Selected_Staff_id && {
            avatar: profileIcon,
            name: "John Doe",
            email: "johndoe@gmail.com",
            staff_id: "wa-0219",
            role: "Director Manager",
            salary: 1000,
        };
        function remove_staff() {
            // remove staff from db
            history.goBack();
        }
        return (
            <div className="view_staff " id="dashboard_panel">
                <div className="staff_data">
                    <div className="staff_personal">
                        <img src={fetched_staff_details.avatar} alt="avatar" className="avatar" />
                        <div className="name_email">
                            <h3 className="name">{fetched_staff_details.name}</h3>
                            <p className="email">{fetched_staff_details.email}</p>
                        </div>
                    </div>
                    <div className="staff_details_wrapper scroll">
                        <table>
                            <thead>
                                <tr>
                                    <th>Staff ID</th>
                                    <th>Role</th>
                                    <th>Salary</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{fetched_staff_details.staff_id}</td>
                                    <td>{fetched_staff_details.role}</td>
                                    <td>{fetched_staff_details.salary}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="cta">
                    <button
                        className="remove_staff outline"
                        onClick={() => {
                            setRemove_Staff_Modal(true);
                        }}
                    >
                        Remove Staff
                    </button>
                    <button className="remove_staff outline">
                        <Link to={`${match.url}/pension_payment`} className="pension outline">
                            Pension Payment
                        </Link>
                    </button>
                </div>
                <ConfirmModal state={Remove_Staff_Modal} control={setRemove_Staff_Modal}>
                    <div className="content">Are you sure you want to remove this staff?</div>
                    <div className="cta_btn">
                        <button
                            onClick={() => {
                                remove_staff();
                                setRemove_Staff_Modal(false);
                            }}
                        >
                            Yes
                        </button>
                        <button onClick={() => setRemove_Staff_Modal(false)}>No</button>
                    </div>
                </ConfirmModal>
            </div>
        );
    }

    function AddStaff() {
        const [f_name, setF_name] = useState("");
        const [staff_id, setStaff_id] = useState("");
        const [email, setEmail] = useState("");
        const [staff_role, setStaff_role] = useState("Manager");
        const [Disbaled, setDisbaled] = useState(true);
        const [salary, setSalary] = useState(18850.43);
        const currency_symbol = useRef();
        const [Currency, setCurrency] = useState("USD");
        useEffect(() => {
            if (
                f_name &&
                staff_id &&
                salary &&
                email.match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                )
            ) {
                setDisbaled(false);
            } else {
                setDisbaled(true);
            }
        }, [f_name, email, staff_id, salary]);
        useEffect(() => {
            switch (Currency) {
                case "USD":
                    currency_symbol.current.innerHTML = "$";
                    break;
                case "EURO":
                    currency_symbol.current.innerHTML = "&euro; ";
                    break;
                case "POUNDS":
                    currency_symbol.current.innerHTML = "&#163; ";
                    break;
                default:
                    currency_symbol.current.innerHTML = "$";
            }
        }, [Currency]);
        return (
            <div className="add_staff_panel">
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                    }}
                >
                    <div className="inputs">
                        <Input
                            header="Staff Name"
                            setValue={setF_name}
                            value={f_name}
                            phold="Enter Staff name"
                        />
                        <DropDownWrapper
                            header="Role"
                            setValue={setStaff_role}
                            value={staff_role}
                            phold={staff_role}
                            className="drop"
                            list={["Manager", "Cheif Excecutive Officer", "Marketing Manager"]}
                            index={2}
                        />
                        <Input
                            header="Staff Id"
                            setValue={setStaff_id}
                            value={staff_id}
                            phold="Enter Staff Id"
                        />
                        <Salary
                            currency_symbol_ref={currency_symbol}
                            Currency={Currency}
                            setCurrency={setCurrency}
                            salary={salary}
                            setSalary={setSalary}
                        />
                        <Input
                            header="Email"
                            setValue={setEmail}
                            value={email}
                            phold="Enter Staff email"
                        />
                    </div>
                    <div className="submit">
                        <button type="submit" className="btn_pry" disabled={Disbaled}>
                            Add Staff
                        </button>
                    </div>
                </form>
            </div>
        );
    }
    function Input({ header, type, value, setValue, phold }) {
        return (
            <div className="input">
                <h4 className="header">{header}</h4>
                <input
                    type={"text"}
                    value={value}
                    onChange={({ target: { value } }) => setValue(value)}
                    placeholder={phold}
                    required={true}
                />
            </div>
        );
    }
    function DropDownWrapper({ header, value, setValue, phold, list, index }) {
        return (
            <div className="input">
                <div className="header">{header}</div>
                <DropDown
                    header={header}
                    initialOption={value}
                    setOption={setValue}
                    width={"100%"}
                    dropListArray={[...list.map((ct) => ({ render: ct, value: ct }))]}
                    placeHolder={phold}
                    customClassNames="input_drop_down"
                    index={index}
                />
            </div>
        );
    }
    function Salary({ currency_symbol_ref, Currency, setCurrency, salary, setSalary }) {
        return (
            <div className="input salary">
                <h4 className="header">Salary</h4>
                <div className="staking_input">
                    <div className="input_feild">
                        <span ref={currency_symbol_ref}></span>
                        <input
                            type="number"
                            name=""
                            id=""
                            value={salary}
                            onChange={({ target: { value } }) => {
                                setSalary(value);
                            }}
                        />
                    </div>
                    <span className="divider"></span>
                    <DropDown
                        header="Select Currency"
                        removeOnExit={true}
                        index={1}
                        dropListArray={[
                            { render: "USD" },
                            { render: "EURO" },
                            { render: "POUNDS" },
                        ]}
                        initialOption={Currency}
                        setOption={setCurrency}
                        width="auto"
                        style={{ marginRight: 24 }}
                    />
                </div>
            </div>
        );
    }
}
